import { useEffect, useState } from '@biletiniz/ui-core';
import { useMutation } from '@biletiniz/apollo';
import { VERIFY_RESET_PASSWORD_CODE } from './gql/verify-reset-password-code';

export const useVerifyResetPasswordCode = () => {
    const [localData, setLocalData] = useState(false);
    const [verifyResetPasswordCodeMutation, { error, loading }] = useMutation(
        VERIFY_RESET_PASSWORD_CODE,
        {
            onCompleted: setLocalData,
        }
    );
    const [loaded, setLoaded] = useState(false);
    const verifyResetPasswordCode = verifyResetPasswordCodeInfo => {
        return verifyResetPasswordCodeMutation({
            variables: verifyResetPasswordCodeInfo,
        });
    };
    useEffect(() => {
        if (localData && !loaded) {
            setLoaded(true);
        }
    }, [localData]);

    const initialValues = {
        confirm: '',
    };

    return {
        localData,
        setLocalData,
        loaded,
        error: error?.message,
        verifyResetPasswordCode,
        loading,
        initialValues,
    };
};
